import pre from './pre';
import cart from './cart.vue';
import config from './config/index.jsx';
import success from './success.vue';
import { planTypes } from '@/common/constants';

export default {
    pre,
    components: {
        config: config(planTypes.CONCURRENCY_MEETING_BASIC),
        cart,
        success
    },
    post: () => { },
}
